import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "src/components/ui/alert-dialog";

type Props = {
  open: boolean;
  onOpenChange: (x: boolean) => void;
  message: string;
  title?: string;
  cancelLabel?: string;
  actionLabel?: string;
  callback?: () => void;
};

const CustomAlertDialog = ({
  open,
  onOpenChange,
  message,
  title,
  cancelLabel = "Cancel",
  actionLabel = "Continue",
  callback,
}: Props) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {/* <AlertDialogTrigger>Open</AlertDialogTrigger> */}
      <AlertDialogContent className="bg-white dark:bg-gray-800">
        <AlertDialogHeader className="text-black dark:text-white">
          <AlertDialogTitle>{title ?? "Are you sure?"}</AlertDialogTitle>
          <AlertDialogDescription>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="text-black dark:text-white">
            {cancelLabel}
          </AlertDialogCancel>
          {callback && (
            <AlertDialogAction onClick={callback}>
              <p>{actionLabel}</p>
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CustomAlertDialog;
